import { render, staticRenderFns } from "./ShareDialog.vue?vue&type=template&id=2d298e3a&scoped=true"
import script from "./ShareDialog.vue?vue&type=script&lang=js"
export * from "./ShareDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareDialog.vue?vue&type=style&index=0&id=2d298e3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d298e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d298e3a')) {
      api.createRecord('2d298e3a', component.options)
    } else {
      api.reload('2d298e3a', component.options)
    }
    module.hot.accept("./ShareDialog.vue?vue&type=template&id=2d298e3a&scoped=true", function () {
      api.rerender('2d298e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/dialogs/ShareDialog.vue"
export default component.exports